import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';

import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';

import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {validateEmpty} from '../../../../global/custom-validate';
import {language} from '../../../../language/vn';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {BsModalService} from 'ngx-bootstrap/modal';
import {DatePipe} from '@angular/common';
import {environment} from '../../../../../environments/environment';
import {LoaiVanBan} from '../../../../models/danhmuc/loaivanban';
import {LinhVucVanBan} from '../../../../models/danhmuc/linhvucvanban';
import {DoMat} from '../../../../models/danhmuc/domat';
import {DoKhan} from '../../../../models/danhmuc/dokhan';
import {LoaiVanBanService} from '../../../../service/danhmuc/service-loaivanban';
import {LinhVucVanBanService} from '../../../../service/danhmuc/service-linhvucvanban';
import {DoMatService} from '../../../../service/danhmuc/service-domat';
import {DoKhanService} from '../../../../service/danhmuc/service-dokhan';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {VanBanDiService} from '../../../../service/vanbandi/service-vanbandi';
import {VanBanDiFileService} from '../../../../service/vanbandi/service-vanbandifile';
import {SelectUnitsOuterComponent} from '../../../ui/selectouter/select.component';
import {NhomVanBanDi} from '../../../../models/vanbandi/nhomvanbandi';
import {NhomVanBanDiService} from '../../../../service/vanbandi/service-nhomvanbandi';
import {Router} from '@angular/router';
import {StaffsService} from '../../../../service/staff/service-staffs';

@Component({
  templateUrl: './create.component.html',

})
export class SoanVanBanDiComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public submitValidate = false;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public dataLoaiVanBan: LoaiVanBan[];
  public dataLinhVuc: LinhVucVanBan[];
  public dataDoMat: DoMat[];
  public dataDoKhan: DoKhan[];
  public dateNgayKy: Date= new Date();
  public dateNgayNhan: Date= new Date();
  public dateNgayVaoSo: Date= new Date();
  public staffSingerList: Object[]=[];
  public selectedSingerList: Object[]=[];
  public unitsOuterList: Object[]=[];
  public selectedUnitsOuterList: Object[]=[];
  public nhomVanBanDi: NhomVanBanDi[] = [];
  constructor(
    public vanBanDiService: VanBanDiService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public vanBanDiFileService: VanBanDiFileService,
    public loaiVanBanService: LoaiVanBanService,
    public linhVucVanBanService: LinhVucVanBanService,
    public doMatService: DoMatService,
    public doKhanService: DoKhanService,
    public datepipe: DatePipe,
    public nhomVanBanDiService: NhomVanBanDiService,
    public router: Router
  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      soVaoSo: new FormControl(),
      maNhomVBdi: new FormControl(),
      maLoaiVB: new FormControl(),
      trichYeu: new FormControl(),
      maLinhVuc: new FormControl(),
      maDoMat: new FormControl(),
      maDoKhan: new FormControl(),
      ngayKy: new FormControl(),
      maNguoiKy: new FormControl(),
      ngayVaoSo: new FormControl(),
      ghiChu: new FormControl(),
      nguoiNhapID: new FormControl()

    });
    this.frmGroup = this.formBuilder.group({
      soVaoSo: ['' , Validators.compose([validateEmpty]) ],
      maNhomVBdi: ['' , Validators.nullValidator],
      maLoaiVB: ['' , Validators.compose([validateEmpty]) ],
      trichYeu: ['' , Validators.compose([validateEmpty]) ],
      maLinhVuc: ['' , Validators.nullValidator],
      maDoMat: ['' , Validators.nullValidator],
      maDoKhan: ['' , Validators.nullValidator],
      ngayKy: ['' , Validators.compose([validateEmpty]) ],
      maNguoiKy: ['' , Validators.nullValidator],
      ngayVaoSo: ['' , Validators.compose([validateEmpty]) ],
      nguoiNhapID: ['', Validators.nullValidator],
      ghiChu: ['', Validators.nullValidator],
      id: ['', Validators.nullValidator]
    });
    this.uploadUrl = this.vanBanDiFileService.urlUpload;
    this.deleteUrl = this.vanBanDiFileService.urlDelete;
    this.loaiVanBanService.getAll().subscribe(data => this.dataLoaiVanBan = data);
    this.linhVucVanBanService.getAll().subscribe(data => this.dataLinhVuc = data);
    this.doMatService.getAll().subscribe(data => this.dataDoMat = data);
    this.doKhanService.getAll().subscribe(data => this.dataDoKhan = data);
    this.nhomVanBanDiService.findByKeyword('').subscribe(dataList => this.nhomVanBanDi = dataList);

  }
  get f() { return this.frmGroup.controls; }

  createItem ()
  {
    if(this.uploadFileComponent.uploadCommand.getFilesData().length >0) {
      this.frmGroup.value.ngayKy = this.datepipe.transform(this.dateNgayKy, 'dd/MM/yyyy');
      this.frmGroup.value.ngayNhan = this.datepipe.transform(this.dateNgayNhan, 'dd/MM/yyyy');
      this.frmGroup.value.ngayVaoSo = this.datepipe.transform(this.dateNgayVaoSo, 'dd/MM/yyyy');
      this.frmGroup.value.maNguoiChuTri = 0;
      this.frmGroup.value.nguoiNhapID = Sessioncommand.staffId;
      this.frmGroup.value.maTrangThaiXL = Number(environment.chogiaoxuly);
      this.frmGroup.value.maNguoiKy = this.selectedSingerList.length > 0 ? this.selectedSingerList[0] : 0;
      this.vanBanDiService.add(this.selectedUnitsOuterList.join(), this.frmGroup.value).subscribe(
        {
          next: (data) => {
            this.uploadFileComponent.id = data.id;
            this.uploadFileComponent.uploadCommand.upload(this.uploadFileComponent.uploadCommand.getFilesData());
            this.toastr.success(language.add_success_record, language.message);
            Sessioncommand.notification = true;
            Sessioncommand.vanBanDiStatus = 0;
            this.router.navigate(['/vanbandi/qlvanbandi'], {  queryParams: {  ty: 'vs' } });
            //this.router.navigate(['/vanbandi/qlvanbandi'], {  queryParams: {  ty: 'dvso' } });
          },
          error: error => {
            this.toastr.error(language.error, language.message);
          }
        });
    }else
    {
      this.toastr.error(language.message_no_file_attach, language.message);
    }
  }
  public showSinger()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSingerList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      if(result != null && result.length >= 1)
      {
          if(this.staffSingerList.some(e => e["id"] === result[0].id)==false) {
            this.staffSingerList= [...this.staffSingerList, {id: result[0].id, fullName: result[0].fullName}];
            this.selectedSingerList= [...this.selectedSingerList, result[0].id];
          }
      }
    });
  }
  public showUnitsOuter()
  {
    const modalEdit = this.bsModalService.show(SelectUnitsOuterComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<SelectUnitsOuterComponent>modalEdit.content).showDonVi(
      this.unitsOuterList
    );
    (<SelectUnitsOuterComponent>modalEdit.content).selectUnits.subscribe(result => {
      if(result != null)
      {
        for (let i = 0; i < result.length; i++) {

          if(this.unitsOuterList.some(e => e["id"] === result[i].id)==false) {
            this.unitsOuterList= [...this.unitsOuterList, {id: result[i].id, fullName: result[i].tenCQ}];
            this.selectedUnitsOuterList= [...this.selectedUnitsOuterList, result[i].id];
          }
        }
      }
    });
  }
  public changeNhom(value: number)
  {

    this.nhomVanBanDiService.getById(value).subscribe(
    data =>
    {
      this.frmGroup.patchValue({soVaoSo : (data.soKhoiTaoVB+ 1).toString()+data.duoiSoKhoiTao});
    }
  );
  }
  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    this.createItem();
  }


}

